"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@emotion/react");
const styles_1 = require("../../styles");
const BodyCell_1 = __importDefault(require("../BodyCell"));
const BodyInner = (_a, externalRef) => {
    var { disableHoverStyles, hideHeaderRow, striped, rows, rowStyles, rowClassNames, prepareRow, onRowClick } = _a, restProps = __rest(_a, ["disableHoverStyles", "hideHeaderRow", "striped", "rows", "rowStyles", "rowClassNames", "prepareRow", "onRowClick"]);
    return (react_1.default.createElement("tbody", Object.assign({}, restProps), rows.map((row, i) => {
        prepareRow(row);
        const _a = row.getRowProps(), { key: rowKey, className: rClassName, style: rStyle } = _a, restRowProps = __rest(_a, ["key", "className", "style"]);
        const rowStyle = Object.assign(Object.assign(Object.assign({}, rStyle), (rowStyles ? rowStyles(row, row.index) : {})), (onRowClick ? { cursor: 'pointer' } : {}));
        return (react_1.default.createElement(react_2.ClassNames, { key: rowKey }, ({ cx }) => (react_1.default.createElement(styles_1.StyledBodyRow, Object.assign({ ref: i === 0 ? externalRef : undefined, "data-testid": "row", key: rowKey, disableHoverStyles: disableHoverStyles, hideHeaderRow: hideHeaderRow }, restRowProps, { striped: i % 2 === 0 && striped, style: rowStyle, className: cx(rClassName, rowClassNames && rowClassNames(row, row.index)), onClick: onRowClick && ((event) => onRowClick(event, row)), onKeyDown: onRowClick &&
                ((event) => event.key === 'Enter' ? onRowClick(event, row) : undefined), tabIndex: onRowClick ? 0 : -1 }), row.cells.map((cell) => {
            const _a = cell.getCellProps(), { key: cellKey } = _a, restCellProps = __rest(_a, ["key"]);
            return (react_1.default.createElement(BodyCell_1.default, Object.assign({ "data-testid": "cell", key: cellKey }, restCellProps), cell.render('Cell')));
        })))));
    })));
};
exports.Body = (0, react_1.forwardRef)(BodyInner);
//# sourceMappingURL=Body.js.map